import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'prRound',
    standalone: false
})
export class PrRoundPipe implements PipeTransform {
  /**
   *
   * @param value
   * @returns {number}
   */
  transform(value: number): number {
    return Math.round(value);
  }
}
